<div class="container-fluid py-4">
  <!-- Header del reporte -->
  <div class="row align-items-center mb-4">
    <div class="col-md-4 text-center text-md-start">
      <img class="logo img-fluid" src="./assets/img/logo.jpeg" alt="Logo Uturunco Studio" style="max-height: 80px;">
      <div class="mt-2">
        <h5 class="mb-0 fw-bold">Uturunco Studio</h5>
        <small class="text-muted">Empresa independiente de desarrollo de software</small>
      </div>
    </div>

    <div class="col-md-4 text-center">
      <h3 class="mb-1 fw-bold text-primary">Reporte de Stock</h3>
      <h6 class="text-muted">App Control Stock — Stock actual por grupo</h6>
    </div>

    <div class="col-md-4 text-center text-md-end">
      <small class="text-muted">
        Resistencia, Chaco<br>
        {{ fecha | date:'dd MM yyyy' }}
      </small>
    </div>
  </div>

  <!-- Resultados -->
  <div class="card shadow-sm">
    <div class="card-header bg-light d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Listado de stock por grupo</h5>
      <small class="text-muted" *ngIf="reporte?.length > 0">
        {{ reporte.length }} grupo{{ reporte.length !== 1 ? 's' : '' }} con stock registrado
      </small>
    </div>

    <div class="card-body p-0">
      <!-- Loading (agrega tu variable loading si la tienes) -->
      <div *ngIf="loading" class="text-center py-5">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Cargando...</span>
        </div>
        <p class="mt-3 text-muted">Obteniendo stock actual...</p>
      </div>

      <!-- Contenido principal -->
      <ng-container *ngIf="!loading">
        <!-- Caso: sin datos -->
        <div *ngIf="reporte?.length === 0" class="text-center text-muted py-5">
          <i class="fas fa-box-open fa-3x mb-3"></i><br>
          No se encontraron grupos con stock registrado.
        </div>

        <!-- Listado por grupos -->
        <div class="accordion" id="stockAccordion" *ngIf="reporte?.length > 0">
          <div class="accordion-item" *ngFor="let grupo of reporte; let i = index">
            <h2 class="accordion-header" id="heading{{i}}">
              <button class="accordion-button" type="button" data-bs-toggle="collapse"
                [attr.data-bs-target]="'#collapse'+i" aria-expanded="true" [attr.aria-controls]="'collapse'+i">
                <div class="d-flex justify-content-between w-100 align-items-center">
                  <span>
                    <strong>{{ grupo.nombre }}</strong>
                  </span>
                  <span class="badge bg-secondary ms-3">
                    {{ grupo.cantidad }} unidades
                  </span>
                </div>
              </button>
            </h2>
            <div id="collapse{{i}}" class="accordion-collapse collapse show" [attr.aria-labelledby]="'heading'+i"
              data-bs-parent="#stockAccordion">
              <div class="accordion-body p-0">
                <div class="table-responsive">
                  <table class="table table-hover table-bordered mb-0">
                    <thead class="table-light">
                      <tr>
                        <th>Nombre del artículo</th>
                        <th class="text-center" style="width: 140px;">Stock actual</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let articulo of grupo.lst">
                        <td>{{ articulo.nombre | uppercase }}</td>
                        <td class="text-center fw-bold">
                          {{ articulo.stock }}
                        </td>
                      </tr>

                      <!-- Fila de total (opcional, pero mejora legibilidad) -->
                      <tr class="table-active fw-bold">
                        <td class="text-end">Total grupo:</td>
                        <td class="text-center">
                          {{ grupo.cantidad }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Versión alternativa sin accordion (si prefieres todo desplegado) -->
        <!-- Descomenta si NO quieres accordion -->
        <!--
                <div class="table-responsive" *ngIf="reporte?.length > 0">
                    <ng-container *ngFor="let grupo of reporte">
                        <table class="table table-striped mb-4">
                            <thead class="table-secondary">
                                <tr>
                                    <th colspan="2">
                                        GRUPO: {{ grupo.nombre }}
                                        <span class="float-end">Total: {{ grupo.cantidad }}</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th>Nombre del mercadería</th>
                                    <th class="text-center" style="width: 140px;">Stock actual</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let art of grupo.lst">
                                    <td>{{ art.nombre | uppercase }}</td>
                                    <td class="text-center">{{ art.stock }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                </div>
                -->
      </ng-container>
    </div>

    <!-- Footer resumen -->
    <div class="card-footer text-end bg-light" *ngIf="reporte?.length > 0 && !loading">
      <small class="text-muted">
        Total de grupos mostrados: <strong>{{ reporte.length }}</strong> •
        Fecha de consulta: <strong>{{ fecha | date:'dd-MM-yyyy' }}</strong>
      </small>
    </div>
  </div>
</div>